
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { SCHEDULE } from '../../assets/mockdata/mocks';
import { Schedule } from '../objects/schedule';
import { ProgrammatieBlok } from '../objects/programmatieblok';
import { ScheduleFilter } from '../objects/schedulefilter';



@Injectable()
export class ScheduleDataService {




  private scheduleUrl = 'assets/mockdata/schedule.json';  // URL to web api

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(
    private http: HttpClient) { }


  
  calcSchedule(schedulefilter: ScheduleFilter): Observable<Schedule> {

    if (location.port != "4200") {
      this.scheduleUrl = '/wp-admin/admin-ajax.php?action=schema_calc';
    }

    return this.http.post<ScheduleFilter>(this.scheduleUrl, schedulefilter).pipe(map(response => response as Schedule),
      tap(_ => this.log('recalculated schedule')),
      catchError(this.handleError<any>('getSchedule', {}))
    );
  }


  cleanSchedule(schedulefilter: ScheduleFilter): Observable<Schedule> {

    if (location.port != "4200") {
      this.scheduleUrl = '/wp-admin/admin-ajax.php?action=schema_delete';
    }

    return this.http.post<ScheduleFilter>(this.scheduleUrl, schedulefilter).pipe(map(response => response as Schedule),
      tap(_ => this.log('cleaned schedule')),
      catchError(this.handleError<any>('getSchedule', {}))
    );
  }


  /** GET heroes from the server */
  getSchedule(schedulefilter: ScheduleFilter): Observable<Schedule> {

    if (location.port != "4200") {
      this.scheduleUrl = '/wp-admin/admin-ajax.php?action=schema_list';
    }

    return this.http.post<Schedule>(this.scheduleUrl, schedulefilter).pipe(map(response => response as Schedule),
      tap(_ => this.log('fetched schedule')),
      catchError(this.handleError<any>('getSchedule', {}))
    );
  }

  updateSchedule(blok: ProgrammatieBlok): Observable<Schedule> {

    if (location.port != "4200") {
      this.scheduleUrl = '/wp-admin/admin-ajax.php?action=schema_update';
    }

    return this.http.post<any>(this.scheduleUrl, blok).pipe(map(response => response as Schedule),
      tap(_ => this.log('updated show')),
      catchError(this.handleError<any>('updateSchedule', {}))
    );
  }

  createSchedule(blok: any): Observable<Schedule> {

    if (location.port != "4200") {
      this.scheduleUrl = '/wp-admin/admin-ajax.php?action=schema_add';
    }

    return this.http.post<any>(this.scheduleUrl, blok).pipe(map(response => response as Schedule),
      tap(_ => this.log('updated show')),
      catchError(this.handleError<any>('createSchedule', {}))
    );


  }


  deleteSchedule(blok: any): Observable<Schedule> {

    if (location.port != "4200") {
      this.scheduleUrl = '/wp-admin/admin-ajax.php?action=schema_deleteid';
    }

    return this.http.post<any>(this.scheduleUrl, blok).pipe(map(response => response as Schedule),
      tap(_ => this.log('updated show')),
      catchError(this.handleError<any>('deleteSchedule', {}))
    );


  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   *
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a HeroService message with the MessageService */
  private log(message: string) {
    console.log(`ScheduleDataService: ${message}`);
  }


}